import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
export function ProductShowcase() {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    id: 'T1',
    icon: '📘',
    title: 'TOMO 1 — Introducción a la Programación y Lógica',
    subtitle: 'La base que todo alumno técnico necesita antes de escribir una sola línea de código.',
    table: [{
      tema: 'Qué es programar',
      aprende: 'Aplicado a la vida real y al contexto técnico industrial'
    }, {
      tema: 'Pensamiento lógico',
      aprende: 'Resolución de problemas paso a paso desde cero'
    }, {
      tema: 'Algoritmos',
      aprende: 'Diseño y representación de soluciones cotidianas y técnicas'
    }, {
      tema: 'Diagramas de flujo',
      aprende: 'Simbología, lectura y construcción normalizada'
    }, {
      tema: 'Variables y tipos de datos',
      aprende: 'Conceptual con ejemplos simples y concretos'
    }, {
      tema: 'Entrada / Proceso / Salida',
      aprende: 'El ciclo base de todo programa explicado para el taller'
    }],
    ficha: '✅ Fichas de clase incluidas: Clase 1 a Clase 5 listas — desde "¿Qué es programar?" hasta resolución de problemas guiados con diagramas de flujo completos.'
  }, {
    id: 'T2',
    icon: '📗',
    title: 'TOMO 2 — Pseudocódigo y Bases Estructuradas',
    subtitle: 'Traducir lógica a lenguaje programable: el puente entre pensar y codificar.',
    table: [{
      tema: 'Pseudocódigo',
      aprende: 'Qué es, para qué sirve y cómo se escribe correctamente'
    }, {
      tema: 'Estructuras secuenciales',
      aprende: 'El orden lógico de instrucciones en un programa'
    }, {
      tema: 'Condicionales',
      aprende: 'If / Else aplicados a problemas técnicos reales'
    }, {
      tema: 'Ciclos',
      aprende: 'While / For con ejemplos del laboratorio técnico'
    }, {
      tema: 'Operadores básicos',
      aprende: 'Aritméticos, relacionales y lógicos en contexto'
    }],
    ficha: '✅ Actividades incluidas: Completar pseudocódigos, detectar errores, crear soluciones propias y mini desafíos progresivos por nivel de dificultad.'
  }, {
    id: 'T3',
    icon: '📙',
    title: 'TOMO 3 — Python Desde Cero (Práctico)',
    subtitle: 'Pasar a código real sin miedo: el primer lenguaje que tiene sentido para el alumno técnico.',
    table: [{
      tema: 'Introducción a Python',
      aprende: 'Por qué Python, cómo instalarlo y cómo ejecutar el primer programa'
    }, {
      tema: 'Variables y tipos',
      aprende: 'Enteros, flotantes, cadenas y booleanos con ejemplos técnicos'
    }, {
      tema: 'Input / Output',
      aprende: 'Programas que interactúan con el usuario desde la primera clase'
    }, {
      tema: 'Condicionales en Python',
      aprende: 'If / elif / else aplicados a problemas del laboratorio'
    }, {
      tema: 'Bucles en Python',
      aprende: 'For y while con ejercicios progresivos paso a paso'
    }],
    ficha: '✅ Actividades incluidas: Ejercicios paso a paso, código incompleto para completar y mini proyectos simples listos para el laboratorio.'
  }, {
    id: 'T4',
    icon: '📕',
    title: 'TOMO 4 — Python Aplicado (Proyectos)',
    subtitle: 'Que el alumno construya cosas reales: del código al producto terminado.',
    table: [{
      tema: 'Funciones',
      aprende: 'Cómo organizar y reutilizar código de forma profesional'
    }, {
      tema: 'Listas',
      aprende: 'Almacenamiento y manejo de datos en programas reales'
    }, {
      tema: 'Manejo de datos simples',
      aprende: 'Lectura, procesamiento y presentación de información'
    }, {
      tema: 'Lógica aplicada',
      aprende: 'Resolución de problemas reales con código Python'
    }],
    proyectos: [{
      nombre: '✔ Calculadora',
      desc: 'Funcional, con operaciones y validación de datos'
    }, {
      nombre: '✔ Sistema de notas',
      desc: 'El alumno diseña y programa un sistema de calificaciones'
    }, {
      nombre: '✔ Juego simple',
      desc: 'Lógica, condiciones y ciclos aplicados de forma entretenida'
    }, {
      nombre: '✔ Conversor de unidades',
      desc: 'Aplicación práctica directa al contexto técnico industrial'
    }],
    ficha: '✅ Guía incluida: Desarrollo paso a paso de cada proyecto + actividades de mejora sobre proyectos existentes.'
  }, {
    id: 'T5',
    icon: '📓',
    title: 'TOMO 5 — Introducción al Desarrollo Web',
    subtitle: 'Crear algo visual: el módulo que más engancha a los alumnos técnicos.',
    table: [{
      tema: 'Cómo funciona una web',
      aprende: 'Estructura, cliente, servidor y navegador explicados sin tecnicismos'
    }, {
      tema: 'HTML — Estructura',
      aprende: 'Etiquetas básicas, jerarquía y construcción de páginas reales'
    }, {
      tema: 'CSS — Estilo',
      aprende: 'Colores, tipografías, layouts y diseño aplicado'
    }, {
      tema: 'Etiquetas básicas',
      aprende: 'Las que el alumno va a usar en el 90% de sus proyectos web'
    }],
    proyectos: [{
      nombre: '✔ Primera página web',
      desc: 'El alumno la construye desde cero en la primera clase'
    }, {
      nombre: '✔ Página personal',
      desc: 'Diseño, contenido y estilo propios'
    }, {
      nombre: '✔ Edición de código existente',
      desc: 'Comprensión y modificación de proyectos reales'
    }],
    ficha: '✅ Actividades incluidas: Crear, diseñar y editar desde la primera clase sin conocimientos previos.'
  }, {
    id: 'T6',
    icon: '📔',
    title: 'TOMO 6 — El Maletín del Docente',
    subtitle: 'La burocracia escolar de programación técnica, resuelta de una vez.',
    table: [{
      tema: 'Planificación Anual editable',
      aprende: 'Lista para presentar: alineada a NAP y marcos INET 2025-2026'
    }, {
      tema: 'Secuencias didácticas',
      aprende: 'Por unidad, desde Tomo 1 hasta Tomo 5, listas para imprimir'
    }, {
      tema: 'Rúbricas de laboratorio',
      aprende: 'Para evaluar código, lógica y proyectos sin subjetividad'
    }, {
      tema: 'Planillas de seguimiento',
      aprende: 'Grupos, rotación en laboratorio y avance por alumno'
    }, {
      tema: 'Banco de 60 preguntas',
      aprende: 'Para examen trimestral con respuestas modelo incluidas'
    }, {
      tema: 'Guía de herramientas gratuitas',
      aprende: 'Para enseñar Python y web sin instalar software de pago'
    }],
    ficha: '✅ Incluye: "Planificación Anual Lista — NAP 2026" con objetivos por trimestre y secuencia de contenidos lista para usar.'
  }];
  const includes = [{
    recurso: '📖 Explicaciones técnicas',
    desc: 'Listas para enseñar sin adaptar ni reescribir'
  }, {
    recurso: '💻 Ejemplos reales',
    desc: 'Del contexto técnico argentino, no de tutoriales extranjeros'
  }, {
    recurso: '📋 Actividades de laboratorio',
    desc: 'Listas para usar en clase sin preparación extra'
  }, {
    recurso: '❓ Preguntas de cierre',
    desc: 'Para el final de cada clase, ya formuladas'
  }, {
    recurso: '📝 Evaluaciones completas',
    desc: 'Con consignas claras y criterios de corrección incluidos'
  }, {
    recurso: '📊 Rúbricas de evaluación',
    desc: 'Para calificar proyectos y código sin discusiones'
  }, {
    recurso: '📅 Secuencias didácticas',
    desc: 'Listas por unidad, adaptables por año de cursada'
  }];
  return <section className="py-6 md:py-12 px-3 bg-brand-card" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        <div className="text-center mb-5" data-id="element-204">
          <h2 className="text-xl md:text-3xl font-black text-white mb-2" data-id="element-205">
            🏆 KIT PROFE™ — PROGRAMACIÓN TÉCNICA LISTA
          </h2>
          <p className="text-base md:text-xl font-bold text-brand-accent neon-glow mb-1" data-id="element-206">
            6 Tomos + 4 Bonos — Todo resuelto.
          </p>
          <p className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-207">
            +400 páginas listas para el laboratorio y el aula.
          </p>
        </div>

        <div className="text-center mb-4" data-id="element-208">
          <h3 className="text-lg font-black text-white inline-flex items-center bg-brand-accent px-4 py-1.5 rounded-lg shadow-lg text-sm md:text-lg" data-id="element-209">
            🖥️ 6 TOMOS COMPLETOS
          </h3>
        </div>

        <div className="space-y-2 mb-6" data-id="element-210">
          {tomos.map((tomo, i) => <div key={i} className="bg-brand-dark border border-white/10 rounded-lg overflow-hidden hover:border-brand-accent transition-colors" data-id="element-211">
              <button onClick={() => setOpenTomo(openTomo === i ? null : i)} className="w-full p-3 md:p-4 text-left flex items-center justify-between focus:outline-none bg-brand-dark" data-id="element-212">
                <div className="flex items-center flex-1" data-id="element-213">
                  <span className="text-xl md:text-2xl mr-2 shrink-0" data-id="element-214">
                    {tomo.icon}
                  </span>
                  <div data-id="element-215">
                    <span className={`block text-sm md:text-base font-black leading-tight ${openTomo === i ? 'text-brand-accent' : 'text-white'}`} data-id="element-216">
                      {tomo.title}
                    </span>
                    <span className="block text-[10px] md:text-sm text-gray-400 font-medium mt-0.5" data-id="element-217">
                      {tomo.subtitle}
                    </span>
                  </div>
                </div>
                {openTomo === i ? <ChevronUp className="w-5 h-5 text-brand-accent shrink-0 ml-2" data-id="element-218" /> : <ChevronDown className="w-5 h-5 text-gray-500 shrink-0 ml-2" data-id="element-219" />}
              </button>

              <div className={`px-3 md:px-4 overflow-hidden transition-all duration-300 ease-in-out bg-[#111] ${openTomo === i ? 'max-h-[2000px] py-3 opacity-100 border-t border-white/10' : 'max-h-0 opacity-0'}`} data-id="element-220">
                <div className="overflow-x-auto mb-3" data-id="element-221">
                  <table className="w-full text-left border-collapse" data-id="element-222">
                    <thead data-id="element-223">
                      <tr className="border-b-2 border-brand-accent/50" data-id="element-224">
                        <th className="py-2 px-2 text-brand-accent font-bold text-xs md:text-sm w-1/3" data-id="element-225">
                          Tema
                        </th>
                        <th className="py-2 px-2 text-brand-accent font-bold text-xs md:text-sm" data-id="element-226">
                          Qué aprende el alumno
                        </th>
                      </tr>
                    </thead>
                    <tbody data-id="element-227">
                      {tomo.table.map((row, idx) => <tr key={idx} className="border-b border-white/5" data-id="element-228">
                          <td className="py-2 px-2 text-white font-semibold text-xs md:text-sm" data-id="element-229">
                            {row.tema}
                          </td>
                          <td className="py-2 px-2 text-gray-300 text-xs md:text-sm" data-id="element-230">
                            {row.aprende}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>

                {tomo.proyectos && <div className="mb-3 bg-brand-dark p-3 rounded-lg border border-white/10" data-id="element-231">
                    <h4 className="text-white font-bold mb-2 flex items-center text-sm" data-id="element-232">
                      <span className="mr-1.5" data-id="element-233">🏗️</span> Proyectos incluidos
                    </h4>
                    <ul className="space-y-1" data-id="element-234">
                      {tomo.proyectos.map((proy, idx) => <li key={idx} className="text-xs md:text-sm flex flex-col md:flex-row md:items-start gap-0.5 md:gap-2" data-id="element-235">
                          <span className="text-brand-accent font-bold whitespace-nowrap" data-id="element-236">
                            {proy.nombre}
                          </span>
                          <span className="hidden md:inline text-gray-500" data-id="element-237">
                            —
                          </span>
                          <span className="text-gray-300" data-id="element-238">{proy.desc}</span>
                        </li>)}
                    </ul>
                  </div>}

                <div className="bg-brand-accent/10 border border-brand-accent/30 p-2.5 rounded-lg" data-id="element-239">
                  <p className="text-xs md:text-sm text-white font-bold" data-id="element-240">
                    {tomo.ficha}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-dark rounded-lg border-2 border-brand-accent overflow-hidden shadow-[0_0_15px_rgba(34,197,94,0.15)]" data-id="element-241">
          <div className="bg-brand-accent py-2.5 px-4 text-center" data-id="element-242">
            <h4 className="text-base md:text-lg font-black text-white" data-id="element-243">
              CADA TOMO INCLUYE:
            </h4>
          </div>
          <div className="p-3 md:p-5" data-id="element-244">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-6" data-id="element-245">
              {includes.map((item, i) => <div key={i} className="flex items-start" data-id="element-246">
                  <CheckCircle2 className="w-4 h-4 text-brand-accent mr-2 shrink-0 mt-0.5" data-id="element-247" />
                  <div data-id="element-248">
                    <span className="text-sm font-bold text-white" data-id="element-249">
                      {item.recurso}
                    </span>
                    <span className="text-xs text-gray-400 ml-1" data-id="element-250">
                      {item.desc}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}